/* tslint:disable */
/* eslint-disable */
/**
 * Tumelo API
 * This is Tumelo\'s API. It drives increased shareholder engagement by providing transparency of the organizations owned by investors and giving them a voice by allowing them to vote on important issues at these organizations.  The main uses of this API are:  * Transparency - To provide a breakdown to an investor of the organizations in which they are invested. * Voting - To provide the ability for an investor to vote on a poll concerning organizations in which they are invested.  ## Status  This API is currently available as a closed **BETA**. We invite interested parties to [give us feedback](mailto:support@tumelo.com) on this API, its documentation, or anything else about Tumelo\'s transparency service prior to the API becoming generally available.  ## Changelog  A changelog for the api can be found [here](CHANGELOG.md).  ## Access The API is available at the following URL: ``` https://api.prod.tumelo.com/v1 ```  For information on how to obtain access to the API, please [contact us](mailto:support@tumelo.com).  ## Development vs Production Habitats Development and Production environments are separated into their own habitats. Please [contact us](mailto:support@tumelo.com) when you\'re ready to go into production and require access to your company\'s live habitat.  # Using the API  ## Case Sensitivity URLs, headers, path parameters, query parameter names, and query parameter values are all case sensitive. Be careful to use the correct case when constructing requests.  ## Error Handling Requests may return an error indicating that there was a problem responding. The response will contain an HTTP status code as well as a JSON object in the following format which describes the error in more detail: ```json {   \"message\": \"Resource not found\" } ```  ## Pagination Requests that return lists and describe pagination parameters support paginated results. Results are separated into multiple pages, where the size of each page is determined by the `pageSize` query parameter. If omitted, `pageSize` defaults to 50 records. When a response includes a `nextPageToken` in the response body, this token value should be passed as a query parameter `nextPageToken` to the same endpoint in order to retrieve the next page of results. This process should be repeated until the response doesn’t include a `nextPageToken`, indicating that the end of the results has been reached.  When passing the `nextPageToken` parameter, all other filter and query parameters present in the previous request, **must** be filled. Filter parameters *must not* be changed while paginating since this will result in an error or an incorrect overall list. The `nextPageToken` will not be present in the response body if the end of the list has been reached and no further results are available.  ## String Formats The following string formats are used throughout this API.  ### date-time The valid format is date-time notation as defined by [RFC 3339, section 5.6](https://tools.ietf.org/html/rfc3339#section-5.6).  For example: `2020-11-30T10:45:28Z`  # Support If you have any technical questions relating to the Tumelo API, please [contact us](mailto:support@tumelo.com), explaining your question or issue in as much detail as possible, including the operation you were performing and the ISIN or Organization ID you were querying, as well as the results you expected and the actual results or error message you observed. You can expect a response within one business day.  ## Data Issues During development and testing in your development habitat we make available a test data set that includes some sample data constructed to illustrate functionality. It is not intended to be used for any purpose other than testing and/or demonstrating functionality, and should not be relied upon to be an accurate reflection of the underlying holdings of any real fund.  If you have any questions or concerns about the data accuracy or completeness of the data in the production environment, please [report the matter](mailto:support@tumelo.com) to us, giving as much information as possible about the issue.  # Compositions and Breakdowns  An instrument may have a composition, this means it is a fund invested in other instruments.  A breakdown is the bottom level components of a composite instrument or account. By this, we mean organizations and cash that a particular composite instrument or account is invested into either directly or through funds.  Breakdowns also have an `other` listing, this is for funds that only have partial information available, or where an instrument is not mapped to an organization. 
 *
 * The version of the OpenAPI document: 0.145.1
 * Contact: support@tumelo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Ballot,
  CastVoteBody,
  CastVotesBody,
  FetchFundManagerVotesRelatedToAccountBody,
  FetchRelatedFundManagerVotesResponse,
  FetchVotingPoliciesResponse,
  GetInvestorBallotResponse,
  GetPollInHabitatResponse,
  InvestorBallotComment,
  InvestorType,
  ListInvestorBallotsResponse,
  ListInvestorMeetingBallotsResponse,
  ListPollTagsResponse,
  ListPollsInHabitatResponse,
  ListVotingRecommendationsResponse,
  MeetingBallot,
  ProposalComment,
} from '../models';
import {
    BallotFromJSON,
    BallotToJSON,
    CastVoteBodyFromJSON,
    CastVoteBodyToJSON,
    CastVotesBodyFromJSON,
    CastVotesBodyToJSON,
    FetchFundManagerVotesRelatedToAccountBodyFromJSON,
    FetchFundManagerVotesRelatedToAccountBodyToJSON,
    FetchRelatedFundManagerVotesResponseFromJSON,
    FetchRelatedFundManagerVotesResponseToJSON,
    FetchVotingPoliciesResponseFromJSON,
    FetchVotingPoliciesResponseToJSON,
    GetInvestorBallotResponseFromJSON,
    GetInvestorBallotResponseToJSON,
    GetPollInHabitatResponseFromJSON,
    GetPollInHabitatResponseToJSON,
    InvestorBallotCommentFromJSON,
    InvestorBallotCommentToJSON,
    InvestorTypeFromJSON,
    InvestorTypeToJSON,
    ListInvestorBallotsResponseFromJSON,
    ListInvestorBallotsResponseToJSON,
    ListInvestorMeetingBallotsResponseFromJSON,
    ListInvestorMeetingBallotsResponseToJSON,
    ListPollTagsResponseFromJSON,
    ListPollTagsResponseToJSON,
    ListPollsInHabitatResponseFromJSON,
    ListPollsInHabitatResponseToJSON,
    ListVotingRecommendationsResponseFromJSON,
    ListVotingRecommendationsResponseToJSON,
    MeetingBallotFromJSON,
    MeetingBallotToJSON,
    ProposalCommentFromJSON,
    ProposalCommentToJSON,
} from '../models';

export interface AddBallotCommentRequest {
    habitatId: string;
    investorId: string;
    ballotId: string;
    investorBallotComment: InvestorBallotComment;
}

export interface AddProposalCommentRequest {
    habitatId: string;
    investorId: string;
    meetingBallotId: string;
    proposalComment: ProposalComment;
}

export interface CastInvestorVotesRequest {
    habitatId: string;
    investorId: string;
    meetingBallotId: string;
    castVotesBody: CastVotesBody;
}

export interface CastVoteRequest {
    habitatId: string;
    investorId: string;
    ballotId: string;
    castVoteBody: CastVoteBody;
}

export interface FetchHabitatVotingPoliciesRequest {
    habitatId: string;
    availableToSchemeId?: string;
    availableToInvestorAccountId?: string;
}

export interface FetchRelatedFundManagerVotesRequest {
    habitatId: string;
    investorId: string;
    ballotId: string;
}

export interface GetInvestorBallotRequest {
    habitatId: string;
    investorId: string;
    ballotId: string;
}

export interface GetInvestorMeetingBallotRequest {
    habitatId: string;
    investorId: string;
    meetingBallotId: string;
}

export interface GetPollInHabitatRequest {
    habitatId: string;
    pollId: string;
}

export interface HandOutInvestorBallotsRequest {
    habitatId: string;
    investorId: string;
}

export interface InvestorAccountFetchRelatedFundManagerVotesRequest {
    habitatId: string;
    investorId: string;
    accountId: string;
    fetchFundManagerVotesRelatedToAccountBody?: FetchFundManagerVotesRelatedToAccountBody;
}

export interface ListHabitatVotingRecommendationsRequest {
    habitatId: string;
    votingPolicyId: string;
    pageSize?: number;
    nextPageToken?: string;
    proposalIds?: Array<string>;
}

export interface ListInvestorBallotsRequest {
    habitatId: string;
    investorId: string;
    pollIds?: Array<string>;
    expireAfter?: Date;
    expireBefore?: Date;
    latestVotingDeadlineAfter?: Date;
    latestVotingDeadlineBefore?: Date;
    createdAfter?: Date;
    createdBefore?: Date;
    hasVoted?: boolean;
    nextPageToken?: string;
    pageSize?: number;
}

export interface ListInvestorMeetingBallotsRequest {
    habitatId: string;
    investorId: string;
    latestVotingDeadlineAfter?: Date;
    latestVotingDeadlineBefore?: Date;
    earliestVotingDeadlineAfter?: Date;
    earliestVotingDeadlineBefore?: Date;
    onlyIncomplete?: boolean;
    investorTypes?: Array<InvestorType>;
    nextPageToken?: string;
    pageSize?: number;
}

export interface ListPollTagsRequest {
    pageSize?: number;
    nextPageToken?: string;
}

export interface ListPollsInHabitatRequest {
    habitatId: string;
    nextPageToken?: string;
    pageSize?: number;
    pollIds?: Array<string>;
    closeTimeBefore?: Date;
    closeTimeAfter?: Date;
    publishedBefore?: Date;
    publishedAfter?: Date;
    organizationIds?: Array<string>;
    onlyHotTopics?: boolean;
}

/**
 * VotingApi - interface
 * 
 * @export
 * @interface VotingApiInterface
 */
export interface VotingApiInterface {
    /**
     * Add a comment to a ballot. This endpoint resolves to a **_Task_** resource that expresses the action of commenting on a ballot.  This can be used to express the reason an investor voted a particular way.  A comment will only be accepted if all the following are true:   * The ballot has not expired.   * The investor has not commented on this ballot already. 
     * @summary Add a comment to a ballot
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} ballotId The ballot identifier.
     * @param {InvestorBallotComment} investorBallotComment The request body to comment on a ballot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    addBallotCommentRaw(requestParameters: AddBallotCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Ballot>>;

    /**
     * Add a comment to a ballot. This endpoint resolves to a **_Task_** resource that expresses the action of commenting on a ballot.  This can be used to express the reason an investor voted a particular way.  A comment will only be accepted if all the following are true:   * The ballot has not expired.   * The investor has not commented on this ballot already. 
     * Add a comment to a ballot
     */
    addBallotComment(requestParameters: AddBallotCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Ballot>;

    /**
     * Adds a comment to a proposal for a specified meeting ballot.  The meeting ballot is returned with proposal comments. 
     * @summary Comment on Proposal
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} meetingBallotId The meeting ballot identifier.
     * @param {ProposalComment} proposalComment The request body to add a comment to a proposal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    addProposalCommentRaw(requestParameters: AddProposalCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeetingBallot>>;

    /**
     * Adds a comment to a proposal for a specified meeting ballot.  The meeting ballot is returned with proposal comments. 
     * Comment on Proposal
     */
    addProposalComment(requestParameters: AddProposalCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeetingBallot>;

    /**
     * Cast a vote on one or more proposals at a meeting.  A vote will only be accepted if all of the following are true:   * The meeting ballot has not expired.   * The investor has not responded with a different response already.   * The proposal being voted on is votable and allows the response given. 
     * @summary Cast votes on a meeting ballot
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} meetingBallotId The meeting ballot identifier.
     * @param {CastVotesBody} castVotesBody The request body to cast votes on a meeting ballot, including the investor\&#39;s responses to one or more votable proposals at the meeting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    castInvestorVotesRaw(requestParameters: CastInvestorVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeetingBallot>>;

    /**
     * Cast a vote on one or more proposals at a meeting.  A vote will only be accepted if all of the following are true:   * The meeting ballot has not expired.   * The investor has not responded with a different response already.   * The proposal being voted on is votable and allows the response given. 
     * Cast votes on a meeting ballot
     */
    castInvestorVotes(requestParameters: CastInvestorVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeetingBallot>;

    /**
     * Cast a vote on a poll. This endpoint resolves to a **_Task_** resource that expresses the action of responding to a ballot and subsequently voting on a poll.  A vote will only be accepted if all the following are true:   * The ballot has not expired.   * The investor has not responded with a different response already. 
     * @summary Cast a vote
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} ballotId The ballot identifier.
     * @param {CastVoteBody} castVoteBody The request body to cast a vote on a ballot. Includes the response the investor gave to the ballot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    castVoteRaw(requestParameters: CastVoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Ballot>>;

    /**
     * Cast a vote on a poll. This endpoint resolves to a **_Task_** resource that expresses the action of responding to a ballot and subsequently voting on a poll.  A vote will only be accepted if all the following are true:   * The ballot has not expired.   * The investor has not responded with a different response already. 
     * Cast a vote
     */
    castVote(requestParameters: CastVoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Ballot>;

    /**
     * Returns voting policies that are available within the given habitat.   This list includes all the policies that can be made available to schemes within this habitat.  This endpoint accepts a maximum of one of the following query parameters: * `availableToSchemeId` returns voting policies that are available within the habitat and are available to the scheme with the ID specified. * `availableToInvestorAccountId` returns voting policies that are available within the habitat and are available to the investor account with the ID specified.  This endpoint does not support setting both parameters at the same time. 
     * @summary Fetch habitat voting policies
     * @param {string} habitatId The habitat identifier.
     * @param {string} [availableToSchemeId] Passing a schemeId will return policies available to accounts belonging to the scheme. 
     * @param {string} [availableToInvestorAccountId] Passing an investor accountId will return only the voting policies available to the given account. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    fetchHabitatVotingPoliciesRaw(requestParameters: FetchHabitatVotingPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchVotingPoliciesResponse>>;

    /**
     * Returns voting policies that are available within the given habitat.   This list includes all the policies that can be made available to schemes within this habitat.  This endpoint accepts a maximum of one of the following query parameters: * `availableToSchemeId` returns voting policies that are available within the habitat and are available to the scheme with the ID specified. * `availableToInvestorAccountId` returns voting policies that are available within the habitat and are available to the investor account with the ID specified.  This endpoint does not support setting both parameters at the same time. 
     * Fetch habitat voting policies
     */
    fetchHabitatVotingPolicies(requestParameters: FetchHabitatVotingPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchVotingPoliciesResponse>;

    /**
     * Fund manager votes are the votes placed by fund managers relating to a proposal.  As a convenience the API allows the listing of fund manager votes related to a ballot.  There may be multiple fund manager votes for a ballot since a ballot may exist due to the ownership of  a non-composite instrument by multiple funds which the investor has in their account composition.  There may also be no fund manager votes for a ballot in the following cases: - The AGM has not occurred yet so the fund manager hasn\'t had the opportunity to vote. - The fund manager did not vote. - The fund manager voted but has not yet reported their vote to Tumelo 
     * @summary Fetch fund manager votes related to a ballot
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} ballotId The ballot identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    fetchRelatedFundManagerVotesRaw(requestParameters: FetchRelatedFundManagerVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchRelatedFundManagerVotesResponse>>;

    /**
     * Fund manager votes are the votes placed by fund managers relating to a proposal.  As a convenience the API allows the listing of fund manager votes related to a ballot.  There may be multiple fund manager votes for a ballot since a ballot may exist due to the ownership of  a non-composite instrument by multiple funds which the investor has in their account composition.  There may also be no fund manager votes for a ballot in the following cases: - The AGM has not occurred yet so the fund manager hasn\'t had the opportunity to vote. - The fund manager did not vote. - The fund manager voted but has not yet reported their vote to Tumelo 
     * Fetch fund manager votes related to a ballot
     */
    fetchRelatedFundManagerVotes(requestParameters: FetchRelatedFundManagerVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchRelatedFundManagerVotesResponse>;

    /**
     * Returns a ballot given the habitat, investor and ballot IDs. 
     * @summary Get investor ballot
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} ballotId The ballot identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    getInvestorBallotRaw(requestParameters: GetInvestorBallotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvestorBallotResponse>>;

    /**
     * Returns a ballot given the habitat, investor and ballot IDs. 
     * Get investor ballot
     */
    getInvestorBallot(requestParameters: GetInvestorBallotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvestorBallotResponse>;

    /**
     * Returns a meeting ballot given the habitat, investor and meeting ballot IDs.
     * @summary Get meeting ballot
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} meetingBallotId The meeting ballot identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    getInvestorMeetingBallotRaw(requestParameters: GetInvestorMeetingBallotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeetingBallot>>;

    /**
     * Returns a meeting ballot given the habitat, investor and meeting ballot IDs.
     * Get meeting ballot
     */
    getInvestorMeetingBallot(requestParameters: GetInvestorMeetingBallotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeetingBallot>;

    /**
     * Returns the poll that has the specified ID. 
     * @summary Get a poll in a habitat
     * @param {string} habitatId The habitat identifier.
     * @param {string} pollId The poll identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    getPollInHabitatRaw(requestParameters: GetPollInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPollInHabitatResponse>>;

    /**
     * Returns the poll that has the specified ID. 
     * Get a poll in a habitat
     */
    getPollInHabitat(requestParameters: GetPollInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPollInHabitatResponse>;

    /**
     * Takes an investor id and triggers the handing out of ballots in a synchronous operation. 
     * @summary Hand Out Ballots
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    handOutInvestorBallotsRaw(requestParameters: HandOutInvestorBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Takes an investor id and triggers the handing out of ballots in a synchronous operation. 
     * Hand Out Ballots
     */
    handOutInvestorBallots(requestParameters: HandOutInvestorBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * Fund manager votes are the votes placed by fund managers relating to a proposal.  As a convenience the API allows the listing of fund manager votes for a list of proposals  based on the fund managers of instruments in the latest composition of this account.  There may be multiple fund manager votes for a proposal because the user might have multiple  fund managers managing instruments in their account and many of these fund managers might have voted.  There may also be no fund manager votes in the following cases: - The AGM has not occurred yet so fund managers haven\'t had the opportunity to vote. - No fund managers voted. - Fund managers voted but have not yet reported their vote to Tumelo. - The user\'s current composition doesn\'t currently contain any instruments managed by fund managers which did vote on the proposal. 
     * @summary Fetch fund manager votes related to an investor account
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {string} accountId The account identifier.
     * @param {FetchFundManagerVotesRelatedToAccountBody} [fetchFundManagerVotesRelatedToAccountBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    investorAccountFetchRelatedFundManagerVotesRaw(requestParameters: InvestorAccountFetchRelatedFundManagerVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchRelatedFundManagerVotesResponse>>;

    /**
     * Fund manager votes are the votes placed by fund managers relating to a proposal.  As a convenience the API allows the listing of fund manager votes for a list of proposals  based on the fund managers of instruments in the latest composition of this account.  There may be multiple fund manager votes for a proposal because the user might have multiple  fund managers managing instruments in their account and many of these fund managers might have voted.  There may also be no fund manager votes in the following cases: - The AGM has not occurred yet so fund managers haven\'t had the opportunity to vote. - No fund managers voted. - Fund managers voted but have not yet reported their vote to Tumelo. - The user\'s current composition doesn\'t currently contain any instruments managed by fund managers which did vote on the proposal. 
     * Fetch fund manager votes related to an investor account
     */
    investorAccountFetchRelatedFundManagerVotes(requestParameters: InvestorAccountFetchRelatedFundManagerVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchRelatedFundManagerVotesResponse>;

    /**
     * Returns voting recommendations for the specified policy. 
     * @summary List voting recommendations
     * @param {string} habitatId The habitat identifier.
     * @param {string} votingPolicyId The voting policy identifier.
     * @param {number} [pageSize] The maximum number of elements to return.
     * @param {string} [nextPageToken] Passing a nextPageToken will cause the next page of results to be retrieved. 
     * @param {Array<string>} [proposalIds] An optional list of proposalIds to filter recommendations list for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    listHabitatVotingRecommendationsRaw(requestParameters: ListHabitatVotingRecommendationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListVotingRecommendationsResponse>>;

    /**
     * Returns voting recommendations for the specified policy. 
     * List voting recommendations
     */
    listHabitatVotingRecommendations(requestParameters: ListHabitatVotingRecommendationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListVotingRecommendationsResponse>;

    /**
     * Returns a list of ballots for a particular investor.  For the investor id, a wildcard `-` may be supplied. In that particular case, all ballots for all the users within a habitat are returned. This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * @summary List investor ballots
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier.
     * @param {Array<string>} [pollIds] includes only ballots that relate to the requested poll IDs
     * @param {Date} [expireAfter] includes only ballots that expire on or after a given time
     * @param {Date} [expireBefore] includes only ballots that expire before a given time
     * @param {Date} [latestVotingDeadlineAfter] includes only ballots that have a latest voting deadline on or after a given time
     * @param {Date} [latestVotingDeadlineBefore] includes only ballots that have a latest voting deadline before a given time
     * @param {Date} [createdAfter] includes only ballots that were created on or after the ballot\&#39;s create time
     * @param {Date} [createdBefore] includes only ballots that were created before the ballot\&#39;s create time
     * @param {boolean} [hasVoted] optional filter to based on whether the investor has used the ballot to vote already
     * @param {string} [nextPageToken] Passing a nextPageToken will cause the next page of results to be retrieved.
     * @param {number} [pageSize] The maximum number of ballots to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    listInvestorBallotsRaw(requestParameters: ListInvestorBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvestorBallotsResponse>>;

    /**
     * Returns a list of ballots for a particular investor.  For the investor id, a wildcard `-` may be supplied. In that particular case, all ballots for all the users within a habitat are returned. This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List investor ballots
     */
    listInvestorBallots(requestParameters: ListInvestorBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvestorBallotsResponse>;

    /**
     * Returns a list of meeting ballots for a particular investor or habitat.  For the investor id, a wildcard `-` may be supplied. In that particular case, all meeting ballots for all the users within a habitat are returned. This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * @summary List investor meeting ballots
     * @param {string} habitatId The habitat identifier.
     * @param {string} investorId The investor identifier. A wildcard &#x60;-&#x60; can be used to return for all investors in habitat.
     * @param {Date} [latestVotingDeadlineAfter] Includes only meeting ballots that have a latest voting deadline on or after a given time.
     * @param {Date} [latestVotingDeadlineBefore] Includes only meeting ballots that have a latest voting deadline before a given time.
     * @param {Date} [earliestVotingDeadlineAfter] Includes only meeting ballots that have their earliest voting deadline on or after a given time.
     * @param {Date} [earliestVotingDeadlineBefore] Includes only meeting ballots that have their earliest voting deadline before a given time.
     * @param {boolean} [onlyIncomplete] Optional filter to only return meeting ballots where the investor has not yet voted on all proposals.
     * @param {Array<InvestorType>} [investorTypes] An optional list of &#x60;investorTypes&#x60; parameters can be provided, regardless of the existence of other query parameters. If no investor type is provided a default of Retail will be used. This parameter is used to filter the meeting ballots by the investor type. The investor type can be one of the following: - institutional - retail 
     * @param {string} [nextPageToken] To receive the next page of results, pass the nextPageToken received on the previous response.
     * @param {number} [pageSize] The maximum number of ballots to return in a single page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    listInvestorMeetingBallotsRaw(requestParameters: ListInvestorMeetingBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvestorMeetingBallotsResponse>>;

    /**
     * Returns a list of meeting ballots for a particular investor or habitat.  For the investor id, a wildcard `-` may be supplied. In that particular case, all meeting ballots for all the users within a habitat are returned. This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List investor meeting ballots
     */
    listInvestorMeetingBallots(requestParameters: ListInvestorMeetingBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvestorMeetingBallotsResponse>;

    /**
     * Returns a list of all poll tags, including the poll tag identifier and the title. 
     * @summary List poll tags
     * @param {number} [pageSize] The maximum number of elements to return.
     * @param {string} [nextPageToken] Passing a nextPageToken will cause the next page of results to be retrieved.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    listPollTagsRaw(requestParameters: ListPollTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPollTagsResponse>>;

    /**
     * Returns a list of all poll tags, including the poll tag identifier and the title. 
     * List poll tags
     */
    listPollTags(requestParameters: ListPollTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPollTagsResponse>;

    /**
     * Lists all polls in a habitat. Polls are ordered by their close date, ascending.  This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * @summary List polls in habitat
     * @param {string} habitatId The habitat identifier.
     * @param {string} [nextPageToken] Passing a nextPageToken will cause the next page of results to be retrieved.
     * @param {number} [pageSize] The maximum number of polls to return.
     * @param {Array<string>} [pollIds] A comma separated list of poll IDs. When provided, the endpoint will only return polls associated with any of the provided IDs.
     * @param {Date} [closeTimeBefore] Passing a close time before date will return polls that have a close time before the specified date.
     * @param {Date} [closeTimeAfter] Passing a close time after date will return polls that have a close time after the specified date.
     * @param {Date} [publishedBefore] Passing a published before date will return polls that have a published time before the specified point.
     * @param {Date} [publishedAfter] Passing a published after date will return polls that have a published time after the specified point.
     * @param {Array<string>} [organizationIds] A comma separated list of organization IDs. When provided, the endpoint will only return polls associated with any of the provided IDs.
     * @param {boolean} [onlyHotTopics] When true only polls with isHotTopic value true returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VotingApiInterface
     */
    listPollsInHabitatRaw(requestParameters: ListPollsInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPollsInHabitatResponse>>;

    /**
     * Lists all polls in a habitat. Polls are ordered by their close date, ascending.  This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List polls in habitat
     */
    listPollsInHabitat(requestParameters: ListPollsInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPollsInHabitatResponse>;

}

/**
 * 
 */
export class VotingApi extends runtime.BaseAPI implements VotingApiInterface {

    /**
     * Add a comment to a ballot. This endpoint resolves to a **_Task_** resource that expresses the action of commenting on a ballot.  This can be used to express the reason an investor voted a particular way.  A comment will only be accepted if all the following are true:   * The ballot has not expired.   * The investor has not commented on this ballot already. 
     * Add a comment to a ballot
     */
    async addBallotCommentRaw(requestParameters: AddBallotCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Ballot>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling addBallotComment.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling addBallotComment.');
        }

        if (requestParameters.ballotId === null || requestParameters.ballotId === undefined) {
            throw new runtime.RequiredError('ballotId','Required parameter requestParameters.ballotId was null or undefined when calling addBallotComment.');
        }

        if (requestParameters.investorBallotComment === null || requestParameters.investorBallotComment === undefined) {
            throw new runtime.RequiredError('investorBallotComment','Required parameter requestParameters.investorBallotComment was null or undefined when calling addBallotComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/ballots/{ballotId}/addComment`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"ballotId"}}`, encodeURIComponent(String(requestParameters.ballotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestorBallotCommentToJSON(requestParameters.investorBallotComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BallotFromJSON(jsonValue));
    }

    /**
     * Add a comment to a ballot. This endpoint resolves to a **_Task_** resource that expresses the action of commenting on a ballot.  This can be used to express the reason an investor voted a particular way.  A comment will only be accepted if all the following are true:   * The ballot has not expired.   * The investor has not commented on this ballot already. 
     * Add a comment to a ballot
     */
    async addBallotComment(requestParameters: AddBallotCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Ballot> {
        const response = await this.addBallotCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a comment to a proposal for a specified meeting ballot.  The meeting ballot is returned with proposal comments. 
     * Comment on Proposal
     */
    async addProposalCommentRaw(requestParameters: AddProposalCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeetingBallot>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling addProposalComment.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling addProposalComment.');
        }

        if (requestParameters.meetingBallotId === null || requestParameters.meetingBallotId === undefined) {
            throw new runtime.RequiredError('meetingBallotId','Required parameter requestParameters.meetingBallotId was null or undefined when calling addProposalComment.');
        }

        if (requestParameters.proposalComment === null || requestParameters.proposalComment === undefined) {
            throw new runtime.RequiredError('proposalComment','Required parameter requestParameters.proposalComment was null or undefined when calling addProposalComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/meetingBallots/{meetingBallotId}/proposalComments`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"meetingBallotId"}}`, encodeURIComponent(String(requestParameters.meetingBallotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProposalCommentToJSON(requestParameters.proposalComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingBallotFromJSON(jsonValue));
    }

    /**
     * Adds a comment to a proposal for a specified meeting ballot.  The meeting ballot is returned with proposal comments. 
     * Comment on Proposal
     */
    async addProposalComment(requestParameters: AddProposalCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeetingBallot> {
        const response = await this.addProposalCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cast a vote on one or more proposals at a meeting.  A vote will only be accepted if all of the following are true:   * The meeting ballot has not expired.   * The investor has not responded with a different response already.   * The proposal being voted on is votable and allows the response given. 
     * Cast votes on a meeting ballot
     */
    async castInvestorVotesRaw(requestParameters: CastInvestorVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeetingBallot>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling castInvestorVotes.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling castInvestorVotes.');
        }

        if (requestParameters.meetingBallotId === null || requestParameters.meetingBallotId === undefined) {
            throw new runtime.RequiredError('meetingBallotId','Required parameter requestParameters.meetingBallotId was null or undefined when calling castInvestorVotes.');
        }

        if (requestParameters.castVotesBody === null || requestParameters.castVotesBody === undefined) {
            throw new runtime.RequiredError('castVotesBody','Required parameter requestParameters.castVotesBody was null or undefined when calling castInvestorVotes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/meetingBallots/{meetingBallotId}/castVotes`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"meetingBallotId"}}`, encodeURIComponent(String(requestParameters.meetingBallotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CastVotesBodyToJSON(requestParameters.castVotesBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingBallotFromJSON(jsonValue));
    }

    /**
     * Cast a vote on one or more proposals at a meeting.  A vote will only be accepted if all of the following are true:   * The meeting ballot has not expired.   * The investor has not responded with a different response already.   * The proposal being voted on is votable and allows the response given. 
     * Cast votes on a meeting ballot
     */
    async castInvestorVotes(requestParameters: CastInvestorVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeetingBallot> {
        const response = await this.castInvestorVotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cast a vote on a poll. This endpoint resolves to a **_Task_** resource that expresses the action of responding to a ballot and subsequently voting on a poll.  A vote will only be accepted if all the following are true:   * The ballot has not expired.   * The investor has not responded with a different response already. 
     * Cast a vote
     */
    async castVoteRaw(requestParameters: CastVoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Ballot>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling castVote.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling castVote.');
        }

        if (requestParameters.ballotId === null || requestParameters.ballotId === undefined) {
            throw new runtime.RequiredError('ballotId','Required parameter requestParameters.ballotId was null or undefined when calling castVote.');
        }

        if (requestParameters.castVoteBody === null || requestParameters.castVoteBody === undefined) {
            throw new runtime.RequiredError('castVoteBody','Required parameter requestParameters.castVoteBody was null or undefined when calling castVote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/ballots/{ballotId}/castVote`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"ballotId"}}`, encodeURIComponent(String(requestParameters.ballotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CastVoteBodyToJSON(requestParameters.castVoteBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BallotFromJSON(jsonValue));
    }

    /**
     * Cast a vote on a poll. This endpoint resolves to a **_Task_** resource that expresses the action of responding to a ballot and subsequently voting on a poll.  A vote will only be accepted if all the following are true:   * The ballot has not expired.   * The investor has not responded with a different response already. 
     * Cast a vote
     */
    async castVote(requestParameters: CastVoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Ballot> {
        const response = await this.castVoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns voting policies that are available within the given habitat.   This list includes all the policies that can be made available to schemes within this habitat.  This endpoint accepts a maximum of one of the following query parameters: * `availableToSchemeId` returns voting policies that are available within the habitat and are available to the scheme with the ID specified. * `availableToInvestorAccountId` returns voting policies that are available within the habitat and are available to the investor account with the ID specified.  This endpoint does not support setting both parameters at the same time. 
     * Fetch habitat voting policies
     */
    async fetchHabitatVotingPoliciesRaw(requestParameters: FetchHabitatVotingPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchVotingPoliciesResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling fetchHabitatVotingPolicies.');
        }

        const queryParameters: any = {};

        if (requestParameters.availableToSchemeId !== undefined) {
            queryParameters['availableToSchemeId'] = requestParameters.availableToSchemeId;
        }

        if (requestParameters.availableToInvestorAccountId !== undefined) {
            queryParameters['availableToInvestorAccountId'] = requestParameters.availableToInvestorAccountId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/votingPolicies:fetch`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FetchVotingPoliciesResponseFromJSON(jsonValue));
    }

    /**
     * Returns voting policies that are available within the given habitat.   This list includes all the policies that can be made available to schemes within this habitat.  This endpoint accepts a maximum of one of the following query parameters: * `availableToSchemeId` returns voting policies that are available within the habitat and are available to the scheme with the ID specified. * `availableToInvestorAccountId` returns voting policies that are available within the habitat and are available to the investor account with the ID specified.  This endpoint does not support setting both parameters at the same time. 
     * Fetch habitat voting policies
     */
    async fetchHabitatVotingPolicies(requestParameters: FetchHabitatVotingPoliciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchVotingPoliciesResponse> {
        const response = await this.fetchHabitatVotingPoliciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fund manager votes are the votes placed by fund managers relating to a proposal.  As a convenience the API allows the listing of fund manager votes related to a ballot.  There may be multiple fund manager votes for a ballot since a ballot may exist due to the ownership of  a non-composite instrument by multiple funds which the investor has in their account composition.  There may also be no fund manager votes for a ballot in the following cases: - The AGM has not occurred yet so the fund manager hasn\'t had the opportunity to vote. - The fund manager did not vote. - The fund manager voted but has not yet reported their vote to Tumelo 
     * Fetch fund manager votes related to a ballot
     */
    async fetchRelatedFundManagerVotesRaw(requestParameters: FetchRelatedFundManagerVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchRelatedFundManagerVotesResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling fetchRelatedFundManagerVotes.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling fetchRelatedFundManagerVotes.');
        }

        if (requestParameters.ballotId === null || requestParameters.ballotId === undefined) {
            throw new runtime.RequiredError('ballotId','Required parameter requestParameters.ballotId was null or undefined when calling fetchRelatedFundManagerVotes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/ballots/{ballotId}/fetchRelatedFundManagerVotes`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"ballotId"}}`, encodeURIComponent(String(requestParameters.ballotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FetchRelatedFundManagerVotesResponseFromJSON(jsonValue));
    }

    /**
     * Fund manager votes are the votes placed by fund managers relating to a proposal.  As a convenience the API allows the listing of fund manager votes related to a ballot.  There may be multiple fund manager votes for a ballot since a ballot may exist due to the ownership of  a non-composite instrument by multiple funds which the investor has in their account composition.  There may also be no fund manager votes for a ballot in the following cases: - The AGM has not occurred yet so the fund manager hasn\'t had the opportunity to vote. - The fund manager did not vote. - The fund manager voted but has not yet reported their vote to Tumelo 
     * Fetch fund manager votes related to a ballot
     */
    async fetchRelatedFundManagerVotes(requestParameters: FetchRelatedFundManagerVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchRelatedFundManagerVotesResponse> {
        const response = await this.fetchRelatedFundManagerVotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a ballot given the habitat, investor and ballot IDs. 
     * Get investor ballot
     */
    async getInvestorBallotRaw(requestParameters: GetInvestorBallotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvestorBallotResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getInvestorBallot.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling getInvestorBallot.');
        }

        if (requestParameters.ballotId === null || requestParameters.ballotId === undefined) {
            throw new runtime.RequiredError('ballotId','Required parameter requestParameters.ballotId was null or undefined when calling getInvestorBallot.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/ballots/{ballotId}`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"ballotId"}}`, encodeURIComponent(String(requestParameters.ballotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvestorBallotResponseFromJSON(jsonValue));
    }

    /**
     * Returns a ballot given the habitat, investor and ballot IDs. 
     * Get investor ballot
     */
    async getInvestorBallot(requestParameters: GetInvestorBallotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvestorBallotResponse> {
        const response = await this.getInvestorBallotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a meeting ballot given the habitat, investor and meeting ballot IDs.
     * Get meeting ballot
     */
    async getInvestorMeetingBallotRaw(requestParameters: GetInvestorMeetingBallotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeetingBallot>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getInvestorMeetingBallot.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling getInvestorMeetingBallot.');
        }

        if (requestParameters.meetingBallotId === null || requestParameters.meetingBallotId === undefined) {
            throw new runtime.RequiredError('meetingBallotId','Required parameter requestParameters.meetingBallotId was null or undefined when calling getInvestorMeetingBallot.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/meetingBallots/{meetingBallotId}`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"meetingBallotId"}}`, encodeURIComponent(String(requestParameters.meetingBallotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeetingBallotFromJSON(jsonValue));
    }

    /**
     * Returns a meeting ballot given the habitat, investor and meeting ballot IDs.
     * Get meeting ballot
     */
    async getInvestorMeetingBallot(requestParameters: GetInvestorMeetingBallotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeetingBallot> {
        const response = await this.getInvestorMeetingBallotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the poll that has the specified ID. 
     * Get a poll in a habitat
     */
    async getPollInHabitatRaw(requestParameters: GetPollInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPollInHabitatResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getPollInHabitat.');
        }

        if (requestParameters.pollId === null || requestParameters.pollId === undefined) {
            throw new runtime.RequiredError('pollId','Required parameter requestParameters.pollId was null or undefined when calling getPollInHabitat.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/polls/{pollId}`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"pollId"}}`, encodeURIComponent(String(requestParameters.pollId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPollInHabitatResponseFromJSON(jsonValue));
    }

    /**
     * Returns the poll that has the specified ID. 
     * Get a poll in a habitat
     */
    async getPollInHabitat(requestParameters: GetPollInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPollInHabitatResponse> {
        const response = await this.getPollInHabitatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Takes an investor id and triggers the handing out of ballots in a synchronous operation. 
     * Hand Out Ballots
     */
    async handOutInvestorBallotsRaw(requestParameters: HandOutInvestorBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling handOutInvestorBallots.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling handOutInvestorBallots.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/ballotsHandOut`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Takes an investor id and triggers the handing out of ballots in a synchronous operation. 
     * Hand Out Ballots
     */
    async handOutInvestorBallots(requestParameters: HandOutInvestorBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.handOutInvestorBallotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fund manager votes are the votes placed by fund managers relating to a proposal.  As a convenience the API allows the listing of fund manager votes for a list of proposals  based on the fund managers of instruments in the latest composition of this account.  There may be multiple fund manager votes for a proposal because the user might have multiple  fund managers managing instruments in their account and many of these fund managers might have voted.  There may also be no fund manager votes in the following cases: - The AGM has not occurred yet so fund managers haven\'t had the opportunity to vote. - No fund managers voted. - Fund managers voted but have not yet reported their vote to Tumelo. - The user\'s current composition doesn\'t currently contain any instruments managed by fund managers which did vote on the proposal. 
     * Fetch fund manager votes related to an investor account
     */
    async investorAccountFetchRelatedFundManagerVotesRaw(requestParameters: InvestorAccountFetchRelatedFundManagerVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchRelatedFundManagerVotesResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling investorAccountFetchRelatedFundManagerVotes.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling investorAccountFetchRelatedFundManagerVotes.');
        }

        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling investorAccountFetchRelatedFundManagerVotes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/accounts/{accountId}/fetchRelatedFundManagerVotes`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FetchFundManagerVotesRelatedToAccountBodyToJSON(requestParameters.fetchFundManagerVotesRelatedToAccountBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FetchRelatedFundManagerVotesResponseFromJSON(jsonValue));
    }

    /**
     * Fund manager votes are the votes placed by fund managers relating to a proposal.  As a convenience the API allows the listing of fund manager votes for a list of proposals  based on the fund managers of instruments in the latest composition of this account.  There may be multiple fund manager votes for a proposal because the user might have multiple  fund managers managing instruments in their account and many of these fund managers might have voted.  There may also be no fund manager votes in the following cases: - The AGM has not occurred yet so fund managers haven\'t had the opportunity to vote. - No fund managers voted. - Fund managers voted but have not yet reported their vote to Tumelo. - The user\'s current composition doesn\'t currently contain any instruments managed by fund managers which did vote on the proposal. 
     * Fetch fund manager votes related to an investor account
     */
    async investorAccountFetchRelatedFundManagerVotes(requestParameters: InvestorAccountFetchRelatedFundManagerVotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchRelatedFundManagerVotesResponse> {
        const response = await this.investorAccountFetchRelatedFundManagerVotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns voting recommendations for the specified policy. 
     * List voting recommendations
     */
    async listHabitatVotingRecommendationsRaw(requestParameters: ListHabitatVotingRecommendationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListVotingRecommendationsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listHabitatVotingRecommendations.');
        }

        if (requestParameters.votingPolicyId === null || requestParameters.votingPolicyId === undefined) {
            throw new runtime.RequiredError('votingPolicyId','Required parameter requestParameters.votingPolicyId was null or undefined when calling listHabitatVotingRecommendations.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        if (requestParameters.proposalIds) {
            queryParameters['proposalIds'] = requestParameters.proposalIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/votingPolicies/{votingPolicyId}/votingRecommendations`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"votingPolicyId"}}`, encodeURIComponent(String(requestParameters.votingPolicyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListVotingRecommendationsResponseFromJSON(jsonValue));
    }

    /**
     * Returns voting recommendations for the specified policy. 
     * List voting recommendations
     */
    async listHabitatVotingRecommendations(requestParameters: ListHabitatVotingRecommendationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListVotingRecommendationsResponse> {
        const response = await this.listHabitatVotingRecommendationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of ballots for a particular investor.  For the investor id, a wildcard `-` may be supplied. In that particular case, all ballots for all the users within a habitat are returned. This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List investor ballots
     */
    async listInvestorBallotsRaw(requestParameters: ListInvestorBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvestorBallotsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listInvestorBallots.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling listInvestorBallots.');
        }

        const queryParameters: any = {};

        if (requestParameters.pollIds) {
            queryParameters['pollIds'] = requestParameters.pollIds;
        }

        if (requestParameters.expireAfter !== undefined) {
            queryParameters['expireAfter'] = (requestParameters.expireAfter as any).toISOString();
        }

        if (requestParameters.expireBefore !== undefined) {
            queryParameters['expireBefore'] = (requestParameters.expireBefore as any).toISOString();
        }

        if (requestParameters.latestVotingDeadlineAfter !== undefined) {
            queryParameters['latestVotingDeadlineAfter'] = (requestParameters.latestVotingDeadlineAfter as any).toISOString();
        }

        if (requestParameters.latestVotingDeadlineBefore !== undefined) {
            queryParameters['latestVotingDeadlineBefore'] = (requestParameters.latestVotingDeadlineBefore as any).toISOString();
        }

        if (requestParameters.createdAfter !== undefined) {
            queryParameters['createdAfter'] = (requestParameters.createdAfter as any).toISOString();
        }

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['createdBefore'] = (requestParameters.createdBefore as any).toISOString();
        }

        if (requestParameters.hasVoted !== undefined) {
            queryParameters['hasVoted'] = requestParameters.hasVoted;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/ballots`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvestorBallotsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of ballots for a particular investor.  For the investor id, a wildcard `-` may be supplied. In that particular case, all ballots for all the users within a habitat are returned. This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List investor ballots
     */
    async listInvestorBallots(requestParameters: ListInvestorBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvestorBallotsResponse> {
        const response = await this.listInvestorBallotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of meeting ballots for a particular investor or habitat.  For the investor id, a wildcard `-` may be supplied. In that particular case, all meeting ballots for all the users within a habitat are returned. This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List investor meeting ballots
     */
    async listInvestorMeetingBallotsRaw(requestParameters: ListInvestorMeetingBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvestorMeetingBallotsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listInvestorMeetingBallots.');
        }

        if (requestParameters.investorId === null || requestParameters.investorId === undefined) {
            throw new runtime.RequiredError('investorId','Required parameter requestParameters.investorId was null or undefined when calling listInvestorMeetingBallots.');
        }

        const queryParameters: any = {};

        if (requestParameters.latestVotingDeadlineAfter !== undefined) {
            queryParameters['latestVotingDeadlineAfter'] = (requestParameters.latestVotingDeadlineAfter as any).toISOString();
        }

        if (requestParameters.latestVotingDeadlineBefore !== undefined) {
            queryParameters['latestVotingDeadlineBefore'] = (requestParameters.latestVotingDeadlineBefore as any).toISOString();
        }

        if (requestParameters.earliestVotingDeadlineAfter !== undefined) {
            queryParameters['earliestVotingDeadlineAfter'] = (requestParameters.earliestVotingDeadlineAfter as any).toISOString();
        }

        if (requestParameters.earliestVotingDeadlineBefore !== undefined) {
            queryParameters['earliestVotingDeadlineBefore'] = (requestParameters.earliestVotingDeadlineBefore as any).toISOString();
        }

        if (requestParameters.onlyIncomplete !== undefined) {
            queryParameters['onlyIncomplete'] = requestParameters.onlyIncomplete;
        }

        if (requestParameters.investorTypes) {
            queryParameters['investorTypes'] = requestParameters.investorTypes;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/investors/{investorId}/meetingBallots`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"investorId"}}`, encodeURIComponent(String(requestParameters.investorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvestorMeetingBallotsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of meeting ballots for a particular investor or habitat.  For the investor id, a wildcard `-` may be supplied. In that particular case, all meeting ballots for all the users within a habitat are returned. This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List investor meeting ballots
     */
    async listInvestorMeetingBallots(requestParameters: ListInvestorMeetingBallotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvestorMeetingBallotsResponse> {
        const response = await this.listInvestorMeetingBallotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of all poll tags, including the poll tag identifier and the title. 
     * List poll tags
     */
    async listPollTagsRaw(requestParameters: ListPollTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPollTagsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/pollTags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPollTagsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of all poll tags, including the poll tag identifier and the title. 
     * List poll tags
     */
    async listPollTags(requestParameters: ListPollTagsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPollTagsResponse> {
        const response = await this.listPollTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all polls in a habitat. Polls are ordered by their close date, ascending.  This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List polls in habitat
     */
    async listPollsInHabitatRaw(requestParameters: ListPollsInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPollsInHabitatResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listPollsInHabitat.');
        }

        const queryParameters: any = {};

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.pollIds) {
            queryParameters['pollIds'] = requestParameters.pollIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.closeTimeBefore !== undefined) {
            queryParameters['closeTimeBefore'] = (requestParameters.closeTimeBefore as any).toISOString();
        }

        if (requestParameters.closeTimeAfter !== undefined) {
            queryParameters['closeTimeAfter'] = (requestParameters.closeTimeAfter as any).toISOString();
        }

        if (requestParameters.publishedBefore !== undefined) {
            queryParameters['publishedBefore'] = (requestParameters.publishedBefore as any).toISOString();
        }

        if (requestParameters.publishedAfter !== undefined) {
            queryParameters['publishedAfter'] = (requestParameters.publishedAfter as any).toISOString();
        }

        if (requestParameters.organizationIds) {
            queryParameters['organizationIds'] = requestParameters.organizationIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.onlyHotTopics !== undefined) {
            queryParameters['onlyHotTopics'] = requestParameters.onlyHotTopics;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/polls`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPollsInHabitatResponseFromJSON(jsonValue));
    }

    /**
     * Lists all polls in a habitat. Polls are ordered by their close date, ascending.  This endpoint is paginated. To fetch the next page, pass the filter and query params from the previous request along with the `nextPageToken` received in the previous response, in the next request. 
     * List polls in habitat
     */
    async listPollsInHabitat(requestParameters: ListPollsInHabitatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPollsInHabitatResponse> {
        const response = await this.listPollsInHabitatRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
